module.exports = __webpack_public_path__ + "img/start4.8af92b30.svg";